var exports = {
  "k": "xe533113f--8c0035--container",
  "Q": "xe533113f--8c0035--text",
};

module.exports = exports;
